import { ReactElement } from 'react'
import styled from 'styled-components'

import { Label } from 'components/v2/Label'
import { IInputProps } from 'components/Input'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { IStyledTextareaProps } from './types'

const TextareaContainer = styled.label``

const StyledTextarea = styled.textarea<IStyledTextareaProps>`
  appearance: none;
  background-color: #ffffff;
  border: 1px solid
    ${({ showError, noBorder }): string => (noBorder ? 'transparent' : showError ? '#FF627B' : '#EAE9E9')};
  border-radius: 4px;
  color: #28265d;
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: ${({ small }): string => (small ? '14px' : '16px')};
  gap: 8px;
  min-height: 80px;
  outline: none;
  padding: ${({ small, noPadding }): string => (noPadding ? '0px' : small ? '6px' : '12px')};
  resize: vertical;
  width: calc(100% - 24px - 2px);

  &:hover,
  &:focus-within {
    border: 1px solid ${({ noBorder }): string => (noBorder ? 'transparent' : '#717171')};
  }

  &:disabled {
    background-color: #f8f8f8;
    border: 1px solid ${({ noBorder }): string => (noBorder ? 'transparent' : '#EAE9E9')};
    color: #b0b0b0;
    cursor: not-allowed;
  }

  &:focus {
    border: 1px solid ${({ noBorder }): string => (noBorder ? 'transparent' : '#717171')};
  }
`

const Textarea = ({
  className,
  label,
  touched,
  errors,
  optional,
  ...props
}: IInputProps<HTMLTextAreaElement>): ReactElement => {
  const showError = Boolean(touched && errors)

  return (
    <TextareaContainer className={className}>
      {label ? <Label optional={optional}>{label}</Label> : null}
      <StyledTextarea {...props} showError={showError} />
      {showError && <ErrorMessage>{errors}</ErrorMessage>}
    </TextareaContainer>
  )
}

export { Textarea }
